// Booking panel on the tour page: date/price calendar, passengers, summary and mobile dock.
export default {
  bookingUi: {
    perAdult: 'por adulto',
    secureNote: 'Pague o sinal com Pix (QR Code ou copia e cola). Você recebe o voucher logo após a confirmação.',
    calendar: {
      prevMonth: 'Mês anterior',
      nextMonth: 'Próximo mês',
      today: 'Hoje',
      selected: 'Selecionado',
      unavailable: 'Indisponível',
      lowest: 'Menor preço do mês',
      legend: 'Legenda do calendário',
      noDate: 'Nenhuma data escolhida',
      noDateHint: 'Toque em um dia para ver o preço.',
      pricePerAdult: '{{price}} por adulto',
    },
    passengers: {
      title: 'Passageiros',
      adults: 'Adultos',
      children: 'Crianças',
      babies: 'Bebês',
      adultsAge: '10 anos ou mais',
      childrenAge: '5 a 9 anos',
      babiesAge: '0 a 4 anos',
      each: '{{price}} cada',
    },
    summary: {
      title: 'Resumo da reserva',
      adultsLine_one: '{{count}} adulto × {{price}}',
      adultsLine_other: '{{count}} adultos × {{price}}',
      childrenLine_one: '{{count}} criança × {{price}}',
      childrenLine_other: '{{count}} crianças × {{price}}',
      babiesLine_one: '{{count}} bebê',
      babiesLine_other: '{{count}} bebês',
      depositNow: 'Sinal agora · Pix',
      fullNow: 'Pagamento total agora · Pix',
    },
    errors: {
      closed: 'Não há saídas nesta data. Escolha outro dia no calendário.',
    },
    dock: {
      label: 'Reserva rápida',
      from: 'A partir de',
      chooseDate: 'Escolher data',
    },
  },
};
